module.exports = __webpack_public_path__ + "r-v3/img/eraser_blue.d3ebb56f.svg";